var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content-editor"},[_c('content-editor-link-input',{ref:"linkEditor",staticStyle:{"z-index":"1001"},attrs:{"link-range":_vm.linkRange,"link-bounds":_vm.linkBounds},on:{"link":_vm.insertCustomLink,"escape":_vm.focus}}),_c('div',{ref:"editor"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }